import { useMeasurementSystem } from 'features/inputs/contexts/measurementSystemContext';
import AsideQuickView from 'shared/components/quick-view/AsideQuickView';
import QuickViewBox from 'shared/components/quick-view/QuickViewBox';
import { formatArea, formatNumeric } from 'utils/format';

const QuickView = ({ isLoading, onMeasurementSystemChange, overview }) => {
  const measurementSystem = useMeasurementSystem();

  const renderQuickView = (name, value, tooltip) => (
    <QuickViewBox name={name} value={value} isLoading={isLoading} tooltip={tooltip} />
  );

  return (
    <AsideQuickView
      title="Quick View"
      measurementSystem={measurementSystem}
      onMeasurementSystemChange={onMeasurementSystemChange}
      isLoading={isLoading}
      fullHeight
    >
      {renderQuickView(
        'Available Area (If Known)',
        formatArea(overview?.availableArea, measurementSystem),
        'Available Usable/Plannable area for an existing project or a newly allocated site as provided in the Inputs page.'
      )}
      {renderQuickView(
        'Total Assigned Headcount',
        formatNumeric(overview?.assignedHeadcount),
        'Number of seated and mobile population. It does not include people who work from home full-time or work at client sites.'
      )}
      {renderQuickView(
        'Total Attending Population',
        formatNumeric(overview?.attendingPopulation),
        'Total number of on-site population per the Attendance Rates provided or specified as defaults in the Inputs page.'
      )}
      {renderQuickView(
        'Total Usable/Plannable Area',
        formatArea(overview?.totalPlannable, measurementSystem),
        'The amount of space required to fulfill the workplace requirements (calculated from the LCS), Specialty spaces, Site-Specific spaces, and circulation. This is not Rentable/Lettable area.'
      )}
      {renderQuickView(
        'Total Rentable/Lettable Area',
        formatArea(overview?.totalRentable, measurementSystem),
        'Total Usable/Plannable is combined with a 4% add-on to account for building support (elevator lobbies, restrooms) and a x% loss factor from the inputs page. This is an approximation of the amount of space that would need to be leased to fulfill all space requirements for this project. If this block is showing zero, you have selected an unknown loss factor as your input, and rentable area cannot be calculated.'
      )}
    </AsideQuickView>
  );
};

export default QuickView;
